// Fault report statuses. The report side sets them, the till only reads them, and
// both the header notice and the modal's table need the same label and colour.

export const ERROR_TICKET_STATUS = {
  open: { color: '#fcad89', labelKey: 'errorTicket.statusOpen' },
  in_progress: { color: '#8fa3d4', labelKey: 'errorTicket.statusInProgress' },
  approved: { color: '#5ad19b', labelKey: 'errorTicket.statusApproved' },
  // Its own tone: sharing the blue made a rejection read as still being looked at
  rejected: { color: '#f27a8d', labelKey: 'errorTicket.statusRejected' },
};

// An unknown status reads as open rather than blanking the row
export const statusTone = (status) =>
  ERROR_TICKET_STATUS[status] ?? ERROR_TICKET_STATUS.open;
